import { ORGANIZATION_SCHEMA, SITE_URL, WEBSITE_SCHEMA } from './seoData.js';

export function buildMetadata({ title, description, image = '/images/flatbed-sunset.webp', noIndex = false, canonicalPath, structuredData = [], ogType = 'website' } = {}, pathname = '/') {
  const path = (canonicalPath ?? pathname).replace(/[?#].*$/, '').replace(/\/+$/, '') || '/';
  return {
    title: title ? `${title} | Jonny's Towing` : "Towing & Roadside Assistance Richmond BC | Jonny's Towing",
    description: description ?? "Professional towing and roadside assistance in Richmond and Greater Vancouver, BC from Jonny's Towing & Recovery.",
    canonical: SITE_URL + path,
    image: image.startsWith('https://') ? image : SITE_URL + image,
    robots: noIndex ? 'noindex,nofollow' : 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1',
    ogType,
    structuredData: noIndex ? null : { '@context': 'https://schema.org', '@graph': [ORGANIZATION_SCHEMA, WEBSITE_SCHEMA, ...(Array.isArray(structuredData) ? structuredData : [structuredData]).filter(Boolean)] },
  };
}

export const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
export function renderHead(meta) {
  const tag = (key, value, attr = 'name') => `<meta ${attr}="${key}" content="${escapeHtml(value)}">`;
  return [
    `<title>${escapeHtml(meta.title)}</title>`, tag('description', meta.description), tag('robots', meta.robots),
    `<link rel="canonical" href="${escapeHtml(meta.canonical)}">`,
    ...Object.entries({ title: meta.title, description: meta.description, image: meta.image, url: meta.canonical, type: meta.ogType, site_name: "Jonny's Towing & Recovery", locale: 'en_CA' }).map(([key, value]) => tag(`og:${key}`, value, 'property')),
    ...Object.entries({ card: 'summary_large_image', title: meta.title, description: meta.description, image: meta.image }).map(([key, value]) => tag(`twitter:${key}`, value)),
    meta.structuredData ? `<script type="application/ld+json" data-jonnys-seo="structured-data">${JSON.stringify(meta.structuredData).replace(/</g, '\\u003c')}</script>` : '',
  ].join('\n');
}
